import React from 'react';
import './ErrorModal.scss';
import { connect } from 'react-redux';
import protoTypes from 'prop-types';
import {ReactComponent as Added} from '../../../assets/added.svg'; 
import {ReactComponent as Added1} from '../../../assets/added1.svg'; 
import {ReactComponent as Clock} from '../../../assets/clock.svg'; 


const ErrorModal = ({ alerts }) => { 
  return (
    <div className='error-modal' >
    {alerts !== null && alerts.length > 0 && alerts.map(alert => {
      switch(alert.alertType) {
        case 'votedTrue':
          return (
            <div key={alert.id}
            className='modal-main animate__animated animate__fadeInUp' > 
              <div className='alert__main'>
                <Added className='logo1' />
                <h2>{alert.msg}</h2>
              </div>
            </div>
          )
        case 'votedFalse':
          return (
            <div key={alert.id}
            className='modal-main animate__animated animate__fadeInUp' > 
              <div className='alert__main'>
                <Added1 className='logo1' />
                <h2>{alert.msg}</h2>
              </div>
            </div>
          )
        case 'Time':
          return (
            <div key={alert.id}
            className='modal-main animate__animated animate__fadeInUp' > 
              <div className='alert__main'>
                <Clock className='logo1' />
                <h4>{alert.msg}</h4>
              </div>
            </div>
          )
        default:
          return (
            <div key={alert.id}
            className={`modal-main animate__animated animate__fadeInUp 
            ${alert.alertType} `} > 
              <div className='error__header'>
                <h3>{alert.alertType}</h3>
              </div>
              <div className='error__main'>
                <span>{alert.msg}</span>
              </div>
            </div>
          )
      }
    })}
    </div>
  )
  
}

ErrorModal.protoTypes = {
  alerts: protoTypes.array.isRequired
}

const mapStateToProps = (state) => ({
  alerts: state.alerts
})

export default connect(mapStateToProps)(ErrorModal);
